import React from 'react';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';
import { ChatWidget } from '../common/ChatWidget';
interface AppLayoutProps {
  children: React.ReactNode;
  onLogout: () => void;
  userRole: string | null;
}
export function AppLayout({
  children,
  onLogout,
  userRole
}: AppLayoutProps) {
  return <div className="min-h-screen bg-slate-50" data-id="element-95">
      <Sidebar onLogout={onLogout} userRole={userRole} data-id="element-96" />
      <TopBar userRole={userRole} data-id="element-97" />
      <main className="ml-64 pt-16 min-h-screen" data-id="element-98">
        <div className="p-6 max-w-7xl mx-auto" data-id="element-99">{children}</div>
      </main>
      <ChatWidget data-id="element-100" />
    </div>;
}